import React from 'react';
import {FullPage} from 'components/container';
import PremiumPlans from './modal/premium_plans'
import store from 'utils/store'
import {push} from 'react-router-redux'

class CreateSubscriptionPage extends React.Component {
  render() {
    return (
      <FullPage withContainer>
        <PremiumPlans mode="custom" backTo={()=>{store.dispatch(push("/"))}}/>
      </FullPage>

    );
  }
}

export default CreateSubscriptionPage;



// WEBPACK FOOTER //
// ./src/components/subscriptions/page.js